export enum VisitorModalContext {
  USER_ACCESS_VALIDITY_EDITMODAL = 'UserAccessValidityEditmodal',
  USER_LIST_NEW_GUESTMODAL = 'UserListNewGuestmodal',
  APARTMENT_USERS_NEW_GUESTMODAL = 'ApartmentUsersNewGuestmodal',
  AA_MODAL_NEW_GUEST_PIN = 'AAmodalNewGuestPIN',
}

export enum VisitorModalOpeningContext {
  AA_USERS_OVERVIEW = 'AA_USERS_OVERVIEW',
  AA_USER_ACCESS_SETTINGS_EDIT = 'AA_USER_ACCESS_SETTINGS_EDIT',
  AA_USER_ACCESS_SETTINGS_REGENERATE = 'AA_USER_ACCESS_SETTINGS_REGENERATE',
  APARTMENT_USERS = 'APARTMENT_USERS',
  APARTMENT_USERS_ROW_MENU = 'APARTMENT_USERS_ROW_MENU',
  GENERATE_NEW_PIN_BUTTON = 'GENERATE_NEW_PIN_BUTTON',
  SECTION_PIN = 'SECTION_PIN',
  SECTION_QR = 'SECTION_QR',
  SITE_USERS = 'SITE_USERS',
  SITE_USERS_ROW_MENU = 'SITE_USERS_ROW_MENU',
  USER_ACCESS_VALIDITY = 'USER_ACCESS_VALIDITY',
}

export const APARTMENT_ADMIN_OPENING_CONTEXTS = new Set([
  VisitorModalOpeningContext.AA_USERS_OVERVIEW,
  VisitorModalOpeningContext.AA_USER_ACCESS_SETTINGS_EDIT,
  VisitorModalOpeningContext.AA_USER_ACCESS_SETTINGS_REGENERATE,
]);

export const DORMAKABA_ACCESS_CHECK_OPENING_CONTEXTS = new Set([
  VisitorModalOpeningContext.APARTMENT_USERS_ROW_MENU,
  VisitorModalOpeningContext.GENERATE_NEW_PIN_BUTTON,
  VisitorModalOpeningContext.SECTION_PIN,
  VisitorModalOpeningContext.SECTION_QR,
  VisitorModalOpeningContext.SITE_USERS_ROW_MENU,
  VisitorModalOpeningContext.USER_ACCESS_VALIDITY,
]);

export const APARTMENT_DEVICES_CHECK_OPENING_CONTEXTS = new Set([VisitorModalOpeningContext.APARTMENT_USERS]);

export const HIDE_CHECKBOX_APARTMENT_ACCESS_OPENING_CONTEXTS = new Set([
  VisitorModalOpeningContext.AA_USER_ACCESS_SETTINGS_EDIT,
  VisitorModalOpeningContext.USER_ACCESS_VALIDITY,
]);
